export * from './menu/menu.component';
